import { useParams } from "react-router-dom";
import {
  NoItemsLeftInTable,
  convertTo12HourFormat,
} from "../../../../../../helpers/helpers";
import { useMediaQuery } from "react-responsive";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import LoadingSkeleton from "../../../../../loader/TableLoader";
import { singleAuctionDetails } from "../../../../../../redux/action/singleAuction";
import Pagination from "../../../../../commanPage/pagination/Pagination";

function InspectionTableforOfferId({
  setCheckedValue,
  checkedValue,
  totalItem,
}) {
  const { id } = useParams();

  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });
  const [auctionData, setAuctionData] = useState([]);
  const [selectAll, setSelectAll] = useState(false); // State to manage header checkbox
  const [checkedRows, setCheckedRows] = useState({});
  const [currentPage, setCurrentPage] = useState(0);
  const dispatch = useDispatch();

  const { singleAuctionData, loading } = useSelector(
    (pre) => pre?.singleAuction
  );

  useEffect(() => {
    dispatch(singleAuctionDetails(id));
  }, [id, dispatch]);

  useEffect(() => {
    if (singleAuctionData && singleAuctionData.offers) {
      const updatedAuctionData = singleAuctionData.offers.map((offer) => ({
        ...offer,
        status: false,
      }));
      setAuctionData(updatedAuctionData);
    }
  }, [singleAuctionData]);

  // Function to toggle individual row checkbox
  const handleRowToggle = (id) => {
    setCheckedRows((prevCheckedRows) => {
      const newCheckedRows = {
        ...prevCheckedRows,
        [id]: !prevCheckedRows[id],
      };

      return newCheckedRows;
    });

    // Check if checkbox is true and add the object to checkedValue array
    if (!checkedRows[id]) {
      setCheckedValue([
        ...checkedValue,
        auctionData.find((item) => item._id === id),
      ]);
    } else {
      setCheckedValue(checkedValue.filter((item) => item._id !== id));
    }
  };

  // Function to toggle header checkbox
  const handleHeaderToggle = () => {
    setSelectAll(!selectAll);
    const newCheckedRows = {};
    auctionData.forEach((item) => {
      newCheckedRows[item._id] = !selectAll;
    });
    setCheckedRows(newCheckedRows);
    if (!selectAll) {
      setCheckedValue(auctionData);
    } else {
      setCheckedValue([]);
    }
  };

  return (
    <>
      {loading ? (
        <div className="valign-wrapper justify-center cover white">
          <LoadingSkeleton
            headerData={[
              "Scrap Type",
              "Offer Time",
              "Quantity / UOM",
              "EMD Amount (Rs.)",
            ]}
          />
        </div>
      ) : (
        <>
          <div className={`${!isTablet && " table-container-style"}`}>
            <table
              className={`responsive-table centered pointer ${
                isTablet ? "auction_table table-style" : "custom-table-style"
              } `}
            >
              <thead>
                <tr>
                  <th>
                    <span
                      className="material-icons-outlined pointer checkToggle"
                      onClick={handleHeaderToggle} // Toggle header checkbox
                      style={{
                        paddingTop: !isTablet ? "5px" : "unset",
                      }}
                    >
                      {selectAll && checkedValue?.length === auctionData?.length
                        ? "check_box"
                        : "check_box_outline_blank"}
                    </span>
                  </th>
                  <th>Scrap Type</th>
                  <th>Offer Time</th>
                  <th>Quantity / UOM</th>
                  <th>EMD Amount (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                {auctionData
                  ?.slice(currentPage, currentPage + totalItem)
                  ?.map((item, index) => (
                    <tr key={item._id}>
                      <td style={{ width: "100px" }}>
                        <span
                          className="material-icons-outlined pointer checkToggle"
                          onClick={() => handleRowToggle(item._id)}
                          style={{
                            paddingTop: !isTablet ? "5px" : "unset",
                          }}
                        >
                          {checkedRows[item._id]
                            ? "check_box"
                            : "check_box_outline_blank"}
                        </span>
                      </td>
                      <td>{item?.scrapDetails?.type}</td>
                      <td>{`${convertTo12HourFormat(
                        item?.offerSchedule?.startTimeAndDate
                      )} - ${convertTo12HourFormat(
                        item?.offerSchedule?.endTimeAndDate
                      )}`}</td>
                      <td>{`${item?.scrapDetails?.quantity} / ${item?.scrapDetails?.unit}`}</td>
                      <td>{item?.EMDAmount}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
            {auctionData?.length === 0 && <NoItemsLeftInTable />}
          </div>
          {auctionData?.length > totalItem && (
            <Pagination
              Data={auctionData}
              totalNumberRow={totalItem}
              setCurrentPage={setCurrentPage}
            />
          )}
        </>
      )}
    </>
  );
}

export default InspectionTableforOfferId;
